import { openEmailModal } from '../State/emailModal'

export default () => (dispatch) => {

  dispatch(openEmailModal())

}
